export enum DocumentType {
  CustomsDocument = 'CustomsDocument',
  CustomsDebitNotifications = 'CustomsDebitNotifications',
  CustomsE1Report = 'CustomsE1Report',
  CustomsE1SalesReport = 'CustomsE1SalesReport',
  CustomsE3Report = 'CustomsE3Report',
  CustomsAnnouncement = 'CustomsAnnouncement',
  DamageReport = 'DamageReport',
  DamageReportAttachment = 'DamageReportAttachment',
  Receipt = 'Receipt',
  CustomExport = 'CustomExport',
  SMSDocument = 'SMSDocument',
  Signature = 'Signature',
  PicturesFromHomeDeliveryHandComputer = 'PicturesFromHomeDeliveryHandComputer',
  Unknown = 'Unknown',
}
